<template>
  <div class="hvh-login">
    <v-layout>
      <v-flex xs4>
        <v-card class="hvh-login-card p-5" elevation="3">
          <v-layout column>
            <v-flex>
              <v-layout pb-5>
                <img src="/fixed-hvh/img/logo_hvh-color.svg" alt="HVH logo" />
                <img src="/fixed-hvh/img/logo_scipheraccess.svg" alt="Scipher Access" class="ml-4" />
              </v-layout>
            </v-flex>
            <h1 class="hvh-h4 mt-5 mb-5">Log in to your account</h1>
            <v-form>
              <v-text-field outline full-width="true" append-icon="mdi-email" label="Email address"></v-text-field>
              <v-text-field outline full-width="true" :append-icon="showPassword ? 'mdi-eye-off' : 'mdi-eye'" :type="showPassword ? 'text' : 'password'" label="Password" @click:append="showPassword = !showPassword"></v-text-field>
              <v-layout>
                <v-flex>
                  <v-checkbox label="Keep me signed in"></v-checkbox>
                </v-flex>
                <v-flex align-self-center class="text-sm-right">
                  <a href="#" class="hvh-login-forgot-pass">Forgot password?</a>
                </v-flex>
              </v-layout>
              <v-btn flat block large class="hvh-btn hvh-btn--primary mt-5">Log In</v-btn>
              <v-alert dismissible value="showError" type="error" class="hvh-login-error mt-2">The email or password you entered is incorrect.</v-alert>
            </v-form>
            <v-flex class="hvh-login-legal mt-5">
              <p class="mb-0">Copyright © 2019 HVH Precision Analytics.</p>
              <p>All rights reserved.</p>
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex>
      <v-flex xs8 class="hvh-login-background">
        <img src="/fixed-hvh/img/login-page.png" class="hvh-login-image" alt />
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
export default {
  data() {
    return {
      showPassword: false,
      showError: true,
    }
  }
}
</script>

<style lang="scss">
.hvh-login {
  width: 100vw;
  background: linear-gradient(-135deg, rgb(29, 132, 144) 0%, rgb(26, 63, 72) 100%);

  .hvh-login-card {
    min-height: 100vh;
    border-radius: 0 16px 16px 0;
  }

  .hvh-login-background {
    min-height: 100vh;
    padding: 0 65px;
    text-align: center;
  }

  .hvh-login-image {
    width: 50vw;
    height: auto;
  }

  .hvh-login-error {
    font-size: rem(16px);
    font-weight: 600;
    line-height: 1.125;
    display: flex;
    align-content: center;

    .theme--light.v-icon {
      color: rgba($color-white, 90%);
    }

    .v-alert__dismissible {
      align-self: center;
    }
  }

  .hvh-login-forgot-pass {
    display: block;
    font-size: rem(16px);
    transform: translateY(-2px);
    font-weight: 600;
  }

  .hvh-login-legal {
    color: $color-gray-3;

    p {
      font-size: rem(14px);
    }
  }
}
</style>
